import { ADMIN_ORDERS } from '../actionTypes';

const initialState = {
  content: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_ORDERS.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
